import { useMemo } from "react";

import useTypedContext from "hooks/useTypedContext";

import { BillingContext } from "../Context";
import { isSelfServiceTier } from "../utils";

const useAvailableSelfServicePlan = () => {
  const { availableSelfServicePlans } = useTypedContext(BillingContext);

  return useMemo(
    () =>
      availableSelfServicePlans
        .map((plan) => ({
          ...plan,
          monthlyPrice: plan.monthlyPrice / 100,
          yearlyPrice: plan.yearlyPrice / 100,
        }))
        .find((plan) => isSelfServiceTier(plan.tier)),
    [availableSelfServicePlans]
  );
};

export default useAvailableSelfServicePlan;
